import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import {CalendarTodayOutlined, Link, People, UploadFile} from '@mui/icons-material'


const actions = [
    { icon: <UploadFile color={"success"}/>, name: 'Upload mp3 message' },
    { icon: <Link color={"primary"}/>, name: 'Update stream link' },
    { icon: <CalendarTodayOutlined />, name: 'Create order of service' },
    { icon: <People color={"secondary"}/>, name: 'Update attendance' },
];

const EventEditMenu = ( { event, setSelectedEvent,handleShowUploadModal, handleShowStreamLinkModal, handleShowOrderOfServiceModal, handleShowUpdateAttendanceModal }) => {

    const handleOnHover = () => {
        setSelectedEvent(event);
    }

    const handleOnLeave = () => {
        setSelectedEvent({})
    }
    return (
        <Box sx={{ transform: 'translateZ(0px)', flexGrow: 1 }}>
            <SpeedDial
                onMouseEnter={handleOnHover}
                onMouseLeave={handleOnLeave}
                ariaLabel="event edit menu"
                sx={{ position: 'absolute', bottom: 20, right: 16 }}
                icon={<SpeedDialIcon/>}
            >
                        <SpeedDialAction key={actions[0].name} icon={actions[0].icon} tooltipTitle={actions[0].name} onClick={handleShowUploadModal}/>
                        <SpeedDialAction key={actions[1].name} icon={actions[1].icon} tooltipTitle={actions[1].name} onClick={handleShowStreamLinkModal}/>
                        <SpeedDialAction key={actions[2].name} icon={actions[2].icon} tooltipTitle={actions[2].name} onClick={handleShowOrderOfServiceModal}/>
                        <SpeedDialAction key={actions[3].name} icon={actions[3].icon} tooltipTitle={actions[3].name} onClick={handleShowUpdateAttendanceModal}/>

            </SpeedDial>
        </Box>
    );
}

export default EventEditMenu;
